import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, Collapse, makeStyles } from '@material-ui/core';
import Scrollbars from '../../scrollbars';
import TextBoxWithTooltip from '../../textBoxWithTooltip';
import ActionButton from '../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    paddingTop: spacing(2),
  },
  label: {
    marginBottom: spacing(2),
  },
  selectedViewport: {
    maxHeight: 100,
  },
  scrollY: {
    right: -15,
  },
  content: {
    display: 'grid',
    gap: 8,
  },
  filterItems: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
  },
  filter: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  filterLabel: {
    maxWidth: 150,
    width: 'fit-content',
  },
  removeButton: {
    width: 24,
    height: 24,
  },
  removeIcon: {
    width: 12,
    height: 12,
  },
}));

const SelectedFilters = ({
  translations,
  selectedFilters,
  isExpanded,
  calculateHeight,
  onRemoveFilter,
}) => {
  const classes = useStyles();

  const onCalculateHeight = () => calculateHeight();

  const handleRemoveFilter = useCallback(
    (selectedFilterId, selectedFilterItemId) => () =>
      onRemoveFilter(selectedFilterId, selectedFilterItemId),
    [onRemoveFilter]
  );

  return (
    <Collapse
      className={classes.root}
      in={isExpanded}
      onEntered={onCalculateHeight}
      onExited={onCalculateHeight}
      unmountOnExit
    >
      <div>
        <Typography className={classes.label} variant="subtitle2">
          {translations.selectedLabel}
        </Typography>
        <Scrollbars
          viewportClass={classes.selectedViewport}
          verticalScrollClass={classes.scrollY}
        >
          <div className={classes.content}>
            {selectedFilters.map(selectedFilter => (
              <div
                key={`filter_id_${selectedFilter.id}`}
                className={classes.filterItems}
              >
                {selectedFilter.selectedItems.map(selectedItem => {
                  return (
                    <div
                      key={`${selectedFilter.id}_${selectedItem.id}`}
                      className={classes.filter}
                    >
                      <TextBoxWithTooltip
                        className={classes.filterLabel}
                        variant="caption"
                        text={`${selectedFilter.name}:`}
                      />
                      <TextBoxWithTooltip
                        className={classes.filterLabel}
                        text={selectedItem?.label || selectedItem.name}
                        variant="overline"
                      />
                      <ActionButton
                        className={classes.removeButton}
                        iconClass={classes.removeIcon}
                        type={ACTION_BUTTON_TYPES.CLOSE}
                        onClickHandler={handleRemoveFilter(
                          selectedFilter.id,
                          selectedItem.id
                        )}
                      />
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </Scrollbars>
      </div>
    </Collapse>
  );
};

SelectedFilters.propTypes = {
  translations: PropTypes.object.isRequired,
};

export default SelectedFilters;
